import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-text-muted q-col-12 suggestions__header q-mt-0 q-mb-0 q-fw-semibold q-text-start"
}
const _hoisted_2 = {
  id: "suggestionsListNew",
  class: "q-list-group q-list-group-flush q-w-100 q-px-0 suggestions__list"
}
const _hoisted_3 = { class: "aggregation-suggestions__header q-text-muted q-fw-semibold q-mt-3 q-mb-1" }
const _hoisted_4 = { class: "q-list-group q-list-group-flush q-w-100 q-px-0 aggregation-suggestions__list" }

import { inject } from 'vue'
import {storeToRefs} from "pinia";
import SingleSuggestion from '@/components/AutocompletePopup/ShowResults/Suggestions/SingleSuggestion.vue';
import AggregationSuggestionItem from '@/components/AutocompletePopup/ShowResults/Suggestions/AggregationSuggestionItem.vue';
import {useSuggestionStore} from "@/store/AutocompletePopup/SuggestionStore";
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {SmartSearchTranslationsInterface} from "@/core/types";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {useAutocompleteAggregationsStore} from "@/store/AutocompletePopup/AutocompleteAggregationsStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SuggestionsContainer',
  setup(__props) {

const suggestionStore = useSuggestionStore()
const {getNewSuggestions} = storeToRefs(suggestionStore)
const mobileViewStore = useMobileViewStore();
const {isMobileView} = storeToRefs(mobileViewStore)

const popupStore = usePopupStore()
const {hasAnyResults} = storeToRefs(popupStore)

const autocompleteAggregationsStore = useAutocompleteAggregationsStore()
const {displayAggregations} = storeToRefs(autocompleteAggregationsStore)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


return (_ctx: any,_cache: any) => {
  return (_unref(hasAnyResults))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["q-col-12 q-col-lg-3 q-pt-1 suggestions__container", {'q-border-bottom q-px-0 q-pb-2': _unref(isMobileView)}]),
        id: "suggestions__container"
      }, [
        (!_unref(isMobileView))
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(SmartSearchTranslations).autocomplete.suggestionsText), 1))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getNewSuggestions), (suggestion) => {
            return (_openBlock(), _createBlock(SingleSuggestion, {
              key: suggestion.query,
              suggestion: suggestion
            }, null, 8, ["suggestion"]))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayAggregations), (aggregation) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: aggregation.field
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(aggregation.label), 1),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aggregation.items, (item) => {
                return (_openBlock(), _createBlock(AggregationSuggestionItem, {
                  key: `${aggregation.field}:${item.id}`,
                  field: aggregation.field,
                  item: item
                }, null, 8, ["field", "item"]))
              }), 128))
            ])
          ], 64))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}
}

})